<template>
  <div v-if="compare" class="acc-stat">
    
    <div class="acc-stat-graph">
      <Graph v-if="drawGraph" :preview="true"/>
      <div class="acc-stat-container">
        <div :class="`acc-stat-cat acc-stat-cat-${key}`" v-for="like, key in compare.categories" :key="key">
          <h3 class="acc-stat-compare">{{ like.compare || 0 }}%</h3>
          <p>{{ getCategoryBySlug(like) || 'Тест'}}</p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';

import Graph from '@/components/Graph';
import findObj from '@/utils/objects';

export default {
  name: 'AccStat',
  components: {
    Graph,
  },
  computed: mapGetters({
    compare: 'compare',
    tags: 'tags',
  }),
  methods: {
    getCategoryBySlug(like) {
      const tag = findObj(this.tags, like.slug, 'slug');
      return tag.name;
    },
  },
  data() {
    return {
      drawGraph: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.drawGraph = true;
    }, 600);
  },
};
</script>

<style>
  .acc-stat{
    margin-bottom: 50px;
    &-graph{
      .graph{
        margin: 0 auto;
        max-height: 300px;
        max-width: 450px;

        &,
        svg{
          position: relative;
          width: 100%;
        }
        svg{
          min-height: 0;
          height: 100%;
        }
      }
    }
    &-container{
      max-width: 450px;
      margin: 0 auto;
    }
    &-cat{
      display: inline-block;
      vertical-align: top;
      text-align: center;
      width: 25%;
    }
    &-compare{
      margin-bottom: 0px;
      font-weight: 300;
    }
  }
</style>



// WEBPACK FOOTER //
// Stat.vue?5a14d0ac